import * as React from 'react';
import styled from 'styled-components';

import Routes from 'routing/Routes';
import * as SecurityRoutes from 'security-app/routing/Routes';
import { Alert, Button } from 'components/bootstrap';
import { IfPermitted } from 'components/common';
import { Row, Col, SmallNavTabs } from 'common/components';
import { DataTable } from 'security-app/components/common';
import type { AssociatedEntitiesType } from 'security-app/hooks/api/eventProceduresAPI.types';

const RoundButton = styled(Button)`
  border-radius: 4px;
`;

const META_BY_ENTITY_TYPE = {
  event_definitions: {
    readableType: 'Event Definition',
    permission: (eventDefinitionId: string) => `eventdefinitions:edit:${eventDefinitionId}`,
    linkURL: (definitionId: string) => Routes.ALERTS.DEFINITIONS.edit(definitionId),
    linkLabel: 'View',
  },
  sigma_rules: {
    readableType: 'Sigma Rule',
    permission: (ruleId: string) => `sigma_rules:edit:${ruleId}`,
    linkURL: () => SecurityRoutes.default.SIGMA.LIST,
    linkLabel: 'To List',
  },
  anomaly_detectors: {
    readableType: 'Anomaly Detector',
    permission: () => 'anomaly_configuration:read',
    linkURL: (detectorId: string) => SecurityRoutes.default.ANOMALIES.DETECTORS.edit(detectorId),
    linkLabel: 'View',
  },
};

const TABS = [
  {
    id: 'event_definitions',
    Label: () => <span>{META_BY_ENTITY_TYPE.event_definitions.readableType}</span>,
  },
  {
    id: 'sigma_rules',
    Label: () => <span>{META_BY_ENTITY_TYPE.sigma_rules.readableType}</span>,
  },
  {
    id: 'anomaly_detectors',
    Label: () => <span>{META_BY_ENTITY_TYPE.anomaly_detectors.readableType}</span>,
  },
];

type Props = {
  associatedEntities: AssociatedEntitiesType;
};

function AssocEntities({ associatedEntities }: Props) {
  const [activeTab, setActiveTab] = React.useState<string>(TABS[0].id);

  return (
    <Col>
      <SmallNavTabs tabs={TABS} activeTab={activeTab} onClick={(tabId: string) => setActiveTab(tabId)} />
      {associatedEntities[activeTab].length > 0 ? (
        <DataTable condensed striped style={{ margin: '16px 0' }}>
          <tbody>
            {associatedEntities[activeTab].map((assocEntity: { id: string; title: string }) => (
              <DataTable.Row key={assocEntity.id}>
                <DataTable.Item>
                  <Row $align="center" style={{ height: '100%' }}>
                    {assocEntity.title}
                  </Row>
                </DataTable.Item>
                <DataTable.Item>
                  <IfPermitted permissions={META_BY_ENTITY_TYPE[activeTab].permission(assocEntity.id)}>
                    <Row $justify="flex-end" style={{ height: '100%' }}>
                      <RoundButton
                        bsSize="xs"
                        href={META_BY_ENTITY_TYPE[activeTab].linkURL(assocEntity.id)}
                        target="_blank">
                        {META_BY_ENTITY_TYPE[activeTab].linkLabel}
                      </RoundButton>
                    </Row>
                  </IfPermitted>
                </DataTable.Item>
              </DataTable.Row>
            ))}
          </tbody>
        </DataTable>
      ) : (
        <Alert style={{ width: '100%' }}>No {META_BY_ENTITY_TYPE[activeTab].readableType}s</Alert>
      )}
    </Col>
  );
}

export default AssocEntities;
